import { Dropdown } from "components/ui";
import { ReactSVG } from "react-svg";
import asset from "assets/images";
import BRANCH_VIEW_ELEMENT_ACTIONS from "../enum";
import { DEPENDENCY_BRANCH_UPDATE_PERMISSION } from "components/dashboard/TrainSAM/Dependency/permissions";
import { CAPSULE_DELETE_PERMISSION } from "components/dashboard/KnowledgeBase/permissions";
import {
    isPostFormBranchCollection,
    POST_FORM_WORKFLOW_UPDATE_PERMISSION,
} from "components/dashboard/KnowledgeBase/PostForms/permissions";
import { baseResources, baseResourceActions } from "routes/enum";

const { AGENTS_INBOX_CONVERSATION_BREAKER } = baseResources;
const { UPDATE } = baseResourceActions;

const getBranchDeleteResources = (branchCollectionType) =>
    isPostFormBranchCollection(branchCollectionType)
        ? POST_FORM_WORKFLOW_UPDATE_PERMISSION
        : [
              ...DEPENDENCY_BRANCH_UPDATE_PERMISSION,
              ...CAPSULE_DELETE_PERMISSION,
              `${UPDATE}_${AGENTS_INBOX_CONVERSATION_BREAKER}`,
          ];

const BranchViewElementDropdown = ({
    handleAction,
    showRemoveBranchOption = true,
    branchCollectionType,
}) => {
    const branchDeleteResources = getBranchDeleteResources(branchCollectionType);
    const dropdownItems = [
        {
            value: BRANCH_VIEW_ELEMENT_ACTIONS.DELETE_BRANCH,
            label: "Delete",
            baseResources: branchDeleteResources,
        },
        {
            value: BRANCH_VIEW_ELEMENT_ACTIONS.DETACH_BRANCH,
            label: "Remove",
            baseResources: branchDeleteResources,
        },
    ];

    const deleteItem = [
        {
            value: BRANCH_VIEW_ELEMENT_ACTIONS.DELETE_BRANCH,
            label: "Delete",
            baseResources: branchDeleteResources,
        },
    ];

    return (
        <Dropdown
            size='sm'
            placeholder={
                <ReactSVG
                    src={asset?.icons?.horizontalEllipsis}
                    className='d-inline-flex'
                />
            }
            ddValueClass='borderless'
            className='table__dropdown'
            ddOptionsClass='table__dropdown'
            anchor={false}
            changeValue={false}
            onChange={({ value }) => handleAction(value)}
            options={showRemoveBranchOption ? dropdownItems : deleteItem}
        />
    );
};

export default BranchViewElementDropdown;
